import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { EnvService } from '../utils/env.service';
import { constants } from '../../../config/app.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private contentHeader: any = {};

  constructor(private http: HttpClient,
    private env: EnvService) {
  }

  getAGRParams(company) {
    const urlHeader = constants.config.apiUrl + constants.config.getContentAGR;
    this.contentHeader = this.http.get(urlHeader, {
      withCredentials: true,
      headers: {
        company: company
      }
    });
    return this.contentHeader;
  }

  getInitData(): Observable<any> {
    const urlHeader = constants.config.apiUrl + constants.config.getInitData;
    this.contentHeader = this.http.get(urlHeader);
    return this.contentHeader;
  }

  getBlockedData(clientId: any): Observable<HttpResponse<any>> {
    console.log(typeof (clientId));
    console.log(clientId);
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/form-data');
    const body: FormData = new FormData();
    const url = constants.config.apiUrl + constants.config.getBlocked;
    body.append('clientId', clientId.toString());
    return this.http.post<any>(url, body, { headers });
  }

  getMenuData(): Observable<HttpResponse<any>> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    const body = {
      appName: "agr"
    };
    const url = constants.config.apiUrl + constants.config.getAppContent;
    return this.http.post<any>(url, body, { headers });
  }
}
